module.exports = __webpack_public_path__ + "img/canvasMenuModifyShape.79f41b07.svg";